var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutMainPages',[_c('div',{staticClass:"flex flex-col"},[_c('WalletBalanceHeader',{on:{"onTriggerAction":_vm.goToPayment}}),_c('WalletTransactions',{attrs:{"parentRoute":"wallet"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }